import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_axnmezu6gc: FaireBrandEntity = {
  token: "b_axnmezu6gc",
  type: "brand",
  name: "Suhkasana",
  avatarUrl:
    "https://cdn.faire.com/fastly/57f218695680dcaacde0ccbd867f70570abd04db4afe1ca07bc28e118e5e468b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1f733785e7a037596e0e75b12c3fcc7f459c33e9ebd6f793218164afb1913945.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/57f218695680dcaacde0ccbd867f70570abd04db4afe1ca07bc28e118e5e468b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1f733785e7a037596e0e75b12c3fcc7f459c33e9ebd6f793218164afb1913945.jpeg",
  location: "Fitchburg, CA, USA",
  minimumOrderDollars: 129,
  rating: 4.9,
  reviewCount: 529,
  isTopShop: true,
  isInsider: true,
  description:
    "About Suhkasana\nAt Suhkasana, we believe beauty is not a standard — it's a celebration of individuality. Born from a desire to redefine how the world sees women’s bodies, Suhkasana is more than a fashion label — it's a movement.\n\n💖 Celebrating Every Curve – We design with real women in mind, embracing every size, shape, and story. Our pieces are made to fit, flatter, and empower.\n🌈 Rooted in Diversity – Founded by Maya, Suhkasana began as a bold vision of inclusion and has grown into a thriving community that uplifts every voice.\n🧘 Comfort Meets Confidence – Inspired by the meaning of “Suhkasana” — a pose of ease — our clothes are crafted to support comfort without compromising style.\n📣 Sparking Change – Through body-positive designs and authentic representation, we aim to inspire women everywhere to love themselves unapologetically.\n🚚 Made for Real Life – With fast and reliable shipping from multiple U.S. locations, we bring beauty and confidence to your doorstep — effortlessly.\n\nJoin the Suhkasana movement — because confidence looks good on every body.\n\nReturn Policy\nThank you for your understanding 💛\nIf a return is not related to a quality issue, the return shipping cost will be the customer’s responsibility.\nPlease make sure all returned items are sent back in their original packaging. Returns without original packaging may not be eligible.\nIf you have any questions, feel free to contact us — we’re happy to help.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:19.684Z",
    importedBy: "entity-db-cli",
  },
};
